<template>
  <div class="position-relative">
    <div class="text-center loading_icon" v-show="questionAnswerLoading">
      <vue-loading type="spin" color="#DB1016" :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
    <ul class="question" v-show="!questionAnswerLoading">
      <li class="big-wrapper js-accordion" v-for="(data, key) in categories" :key="key" v-show="data.count > 0"><a class="big-link js-accordion--trigger" :class="{ 'active': getIsOpened[key] }" @click="setIsOpended(key)">Q. {{ data.name}}</a>
        <transition name="js-accordion" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
          <div class="js-accordion--target" :class="{ '_state-open': getIsOpened[key] }" v-if="getIsOpened[key]">
            <ul class="acordion js-accordion--body" :class="data.slug">
              <li v-for="(data2, key2) in qaList" :key="key2">
                <div v-if="data2.category_name == data.name">
                  <router-link class="small-link" :to="{name: 'faq.detail', params: {id: data2.id}}">{{ data2.title.rendered}}</router-link>
                </div>
              </li>
            </ul>
          </div>
        </transition>
      </li>
    </ul>
  </div>
</template>
<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import { VueLoading } from 'vue-loading-template'

  export default {
    name: 'faq_faq',
    components: {
      VueLoading,
    },
    data() {
      return {
        qaList: this.questionAnswers,
      }
    },
    methods: {
      ...mapActions('faq', ['getQuestionAnswers', 'getCategories', 'setIsOpended']),
      // ...mapActions('faq', []),
      // eslint-disable-next-line
      // accordionToggle: function (val) {
        // this.isOpened[val] = !this.isOpened[val]
      // },
      // eslint-disable-next-line
      beforeEnter: function (el) {
        // eslint-disable-next-line
        el.style.height = '0'
      },
      // eslint-disable-next-line
      enter: function (el) {
        // eslint-disable-next-line
        el.style.height = el.scrollHeight + 'px'
      },
      // eslint-disable-next-line
      beforeLeave: function (el) {
        // eslint-disable-next-line
        el.style.height = el.scrollHeight + 'px'
      },
      // eslint-disable-next-line
      leave: function (el) {
        // eslint-disable-next-line
        el.style.height = '0'
      },
    },
    computed: {
      ...mapState('faq', ['questionAnswerLoading', 'currentId', 'isOpened']),
      ...mapGetters('faq', ['questionAnswers', 'categories', 'getIsOpened']),
    },
    created() {
      // if (this.questionAnswers.length === 0) {
        this.getCategories()
        this.getQuestionAnswers()
      // } else {
        this.$set(this, 'qaList', this.questionAnswers)
        // this.$set(this, 'qaList', this.questionAnswers2)
      // }
    },
    mounted() {
    },
    watch: {
      questionAnswers(data) {
        this.$set(this, 'qaList', data)
      },
    },
  }
</script>
<style lang="scss" scoped>
.loading_icon{
  width: 100%;
  position: absolute;
  top:0;
}
</style>
